// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"01bb45da","100":"190b1e3e","112":"f568634b","204":"5fc459b4","356":"92aa98d5","432":"ad0b6381","472":"59d70c95","748":"ecb7827f"}[chunkId] + ".chunk.js";
};